import { IComposeEmailData } from "src/types/mail";
import axios from "../axios/axios";

const formatEmailData = (payload: any) => {
  const formData = new FormData();
  for (const key in payload) {
    if (key === "attachments") {
      payload[key].forEach((file: any) => {
        formData.append("attachments", file);
      });
    } else if (key === "to") {
      formData.append(key, JSON.stringify(payload[key]));
    } else {
      formData.append(key, payload[key]);
    }
  }
  return formData;
};

const getAllEmails = async (
  email: string,
  pageToken: string,
  folderId: string,
  searchEmails: string,
  threadId: string
) => {
  try {
    const { data } = await axios.get(
      `mailbox?email=${email}&limit=20&page_token=${pageToken}&folderId=${folderId}&searchEmails=${searchEmails}&threadId=${threadId}`
    );
    return {
      status: data.status,
      message: data.message,
      data: data.data,
    };
  } catch (e: any) {
    console.log("error:", e);
    throw e;
  }
};

const getFolderList = async (email: string) => {
  try {
    const { data } = await axios.get(`mailbox/folderList?email=${email}`);
    return data;
  } catch (e: any) {
    console.log("error:", e);
    throw e;
  }
};

const getEmailById = async (email: string, emailId: string) => {
  try {
    const { data } = await axios.get(
      `/mailbox/email/${emailId}?email=${email}`
    );
    return data;
  } catch (e: any) {
    console.log("error:", e);
    throw e;
  }
};

const sendEmail = async (
  payload: IComposeEmailData,
  reply_to?: string,
  reply_to_message_id?: string
) => {
  try {
    const formData = formatEmailData({
      ...payload,
      reply_to,
      reply_to_message_id,
    });
    const { data } = await axios.post("/mailbox/createAndSendDraft", formData);
    return {
      status: data.status,
      message: data.message,
      data: data.data,
    };
  } catch (e: any) {
    console.log("error:", e);
    throw e;
  }
};

const createDraft = async (payload: IComposeEmailData) => {
  try {
    const formData = formatEmailData(payload);
    const { data } = await axios.post("/mailbox/createDraft", formData);
    return {
      status: data.status,
      message: data.message,
      data: data.data,
    };
  } catch (error: any) {
    throw error;
  }
};

const updatedDraft = async (draftId: string, payload: IComposeEmailData) => {
  try {
    const draftData = {
      email: payload.email,
      to: payload.to,
      Subject: payload.subject,
      body: payload.body,
    };
    const formData = formatEmailData({
      requestBody: JSON.stringify(draftData),
      draftId,
      attachments: payload.attachments,
    });
    const { data } = await axios.put("/mailbox/updateDraft", formData);
    return {
      status: data.status,
      message: data.message,
      data: data.data,
    };
  } catch (e: any) {
    console.log("error:", e);
    throw e;
  }
};

const getAllDrafts = async (email: string, pageToken: string) => {
  try {
    const { data } = await axios.get(
      `/mailbox/drafts?email=${email}&limit=20&page_token=${pageToken}`
    );
    return data;
  } catch (error: any) {
    console.log(error);
    throw error;
  }
};

const getDraftById = async (email: string, draftId: string) => {
  try {
    const { data } = await axios.get(
      `/mailbox/draft/${draftId}?email=${email}`
    );
    return data;
  } catch (e: any) {
    console.log("error:", e);
    throw e;
  }
};

const deleteDraftById = async (email: string, draftId: string) => {
  try {
    const { data } = await axios.delete(
      `/mailbox/deleteDraft/${draftId}?email=${email}`
    );
    return {
      status: data.status,
      message: data.message,
      data: data.data,
    };
  } catch (e: any) {
    console.log("error:", e);
    throw e;
  }
};

const downloadEmailAttachmentById = async (
  email: string,
  messageId: string,
  attachmentId: string
) => {
  try {
    const { data } = await axios.get(
      `/mailbox/attachment/download?email=${email}&messageId=${messageId}&attachmentId=${attachmentId}`
    );
    return data;
  } catch (e: any) {
    console.log("error:", e);
    throw e?.response?.data;
  }
};

const getThreadsByThreadId = async (userEmail: string, threadId: string) => {
  try {
    const { data } = await axios.get(
      `mailbox/threads/${threadId}?email=${userEmail}`
    );
    return data;
  } catch (e: any) {
    console.log("error:", e);
    throw e;
  }
};

const connectMailBox = async (mailboxProvider:string) => {
  try {
    const { data } = await axios.get(`/mailbox/connectMailbox?mailboxProvider=${mailboxProvider}`);
    return data;
  } catch (e: any) {
    console.log("error:", e);
    throw e;
  }
};

const disConnectMailbox = async (mailboxId: string) => {
  try {
    const { data } = await axios.delete(
      `/mailbox/disconnectMailbox/${mailboxId}`
    );
    return data;
  } catch (e: any) {
    console.log("error:", e);
    throw e;
  }
};

const updateMailStatus = async (
  email: string,
  mailId: string,
  unread?: boolean,
  starred?: boolean
) => {
  try {
    const payload: any = {};
    if (typeof unread === "boolean") payload.unread = unread;
    if (typeof starred === "boolean") payload.starred = starred;
    console.log("payload:", payload);
    const { data } = await axios.patch(
      `/mailbox/updateEmailStatus/${mailId}?email=${email}`,
      payload
    );
    return data;
  } catch (e: any) {
    console.log("error:", e);
    throw e;
  }
};

const getActiveMailboxProvider = async () => {
  try {
    const { data } = await axios.get("/mailbox/fetchActiveProvider");
    return data;
  } catch (e: any) {
    console.log("error:", e);
    throw e;
  }
};

const deleteMultipleEmails = async (emailIds: string[], userEmail: string) => {
  try {
    const { data } = await axios.delete(
      `/mailbox/deleteMails?email=${userEmail}`,
      { data: { emailIds } }
    );
    return data;
  } catch (e: any) {
    console.log("error:", e);
    throw e;
  }
};

//get all active mailbox integration for a organization
const getMailboxIntegrationsByOrg = async () => {
  try {
    const { data } = await axios.get(`/mailbox/activeIntegrations`);
    return data;
  } catch (e: any) {
    console.log("error:", e);
    throw e;
  }
};

export const mailService = {
  getAllEmails,
  getFolderList,
  getEmailById,
  sendEmail,
  createDraft,
  getAllDrafts,
  getDraftById,
  deleteDraftById,
  downloadEmailAttachmentById,
  updatedDraft,
  getThreadsByThreadId,
  connectMailBox,
  disConnectMailbox,
  updateMailStatus,
  getActiveMailboxProvider,
  deleteMultipleEmails,
  getMailboxIntegrationsByOrg
};
